import {styled} from "styled-components";

export const MarkdownContainer = styled.div`
    table {
        width: 100%;
        border-collapse: collapse;
        margin: 1em 0;
        font-family: Arial, sans-serif;
    }

    th, td {
        border: 1px solid #ccc;
        padding: 8px;
        text-align: left;
    }

    th {
        background-color: #f2f2f2;
        font-weight: bold;
    }

    td {
        background-color: #fff;
    }

    tr:nth-child(even) {
        background-color: #f9f9f9;
    }

    tr:hover {
        background-color: #f1f1f1;
    }

    pre {
        background-color: #f4f4f4;
        padding: 1em;
        border-radius: 5px;
        overflow-x: auto;
        font-family: "Courier New", Courier, monospace;
        white-space: pre-wrap;
        word-wrap: break-word;
    }

    ul, ol {
        margin: 1em 0;
        padding-left: 20px;
    }

    li {
        line-height: 1.6;
    }

    ul {
        list-style-type: disc;
    }

    ol {
        list-style-type: decimal;
    }

`
